import React, { useEffect } from "react";
import { TextInput } from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { facilityAction } from "../../_store";
import { facilitySchema } from "../../validation/facilitySchema";

function FacilityWebService({ errorMessage, setErrorMessage }) {
  const dispatch = useDispatch();

  const facilityInformationData = useSelector((x) => x?.facility?.facilityData);

  useEffect(() => {
    let facilityData = { ...facilityInformationData };

    if (
      facilityData?.InmateUploadType === 2 ||
      facilityData?.IsInmateCactasCredit === true
    ) {
      facilityData["isValidateWebService"] = 1;
    } else {
      facilityData["isValidateWebService"] = 0;
    }
    dispatch(facilityAction?.setFacilityData(facilityData));
    return () => {
      dispatch(facilityAction?.disableWebServiceValidation());
    };
  }, []);

  const handleChange = (e) => {
    const facilityData = { ...facilityInformationData };
    const { name, value } = e?.target;
    if (name === "CactasAccessKey") {
      const regex = /^[a-zA-Z0-9_-]*$/; //allow only alphanumeric and -_
      if (!regex.test(value)) return;
      facilityData[name] = value;
    } else {
      facilityData[name] = value;
    }
    dispatch(facilityAction.setFacilityData(facilityData));
  };

  const handleBlurWebServicelInfo = async (e) => {
    let { name, value } = e.target;
    const facilityData = { ...facilityInformationData };
    try {
      // Clear error if validation passes
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "", // Clear the specific field error
      }));
      facilityData[name] = value ? value.trim() : "";
      dispatch(facilityAction.setFacilityData(facilityData));
      // Validate the field using the Joi schema and handle both required and other validation
      let objField = { [name]: value };
      await facilitySchema.validateAsync(
        {
          ...objField,
          InmateUploadType: facilityInformationData?.InmateUploadType,
          IsInmateCactasCredit: facilityInformationData?.IsInmateCactasCredit,
        },
        { abortEarly: false }
      );
    } catch (err) {
      // Find the error that matches the current field name
      const fieldError = err.details.find((error) => error.path.includes(name));

      if (fieldError) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError.message, // Set the specific field error from Joi
        }));
      }
    }
  };

  return (
    <div className="mt-3 mb-3">
      <h4
        className="inner-header-bg text-color"
        style={{ cursor: "pointer" }}
        title=""
      >
        <i className="fas fa-globe me-2"></i>Web Service{" "}
      </h4>
      <div className="row mb-12">
        <div className="col-md-6">
          <div className="form-floating mb-3">
            <TextInput
              name="CactasURL"
              id="CactasURL"
              label="CACTAS URL"
              value={facilityInformationData.CactasURL}
              placeholder="https://demo.cactas.com/"
              required
              errorMessage={errorMessage}
              handleChange={handleChange}
              maxLength={100}
              handleBlur={handleBlurWebServicelInfo}
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-floating mb-3">
            <TextInput
              name="CactasAccessKey"
              id="CactasAccessKey"
              label="CACTAS Access Key"
              value={facilityInformationData.CactasAccessKey}
              placeholder="Enter CACTAS Access Key"
              required
              errorMessage={errorMessage}
              handleChange={handleChange}
              maxLength={50}
              handleBlur={handleBlurWebServicelInfo}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(FacilityWebService);
